import React from "react";

export const tourSteps = [
  {
    selector: '[data-tour="1"]',
    content: (
      <div>
        <h4 tabindex="0">Welcome to the Neurosphere Simulator Tool!</h4>
        <p>
          If this is your first time using our tool, we recommend you take a
          brief guided tour to explore the functionalities this Simulator has to
          offer.
          <br></br>
          <br></br>
          You can press the exit button to exit the tour at any time.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 1",
  },
  {
    selector: '[data-tour="2"]',
    content: (
      <div>
        <h4 tabindex="0">Simulator Phases</h4>
        <p>
          Each simulation consists of 2 phases:<br></br>
          <br></br>Initialization → Simulation <br></br>
          <br></br>The simulation phase cannot execute until the initialization
          phase is completed.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 2",
  },
  {
    selector: '[data-tour="3"]',
    content: (
      <div>
        <h4 tabindex="0">Initialization</h4>
        <p>
          Let’s start with the initialization phase!<br></br>
          <br></br>Here you can adjust all the model parameters.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 3",
  },
  {
    selector: '[data-tour="7"]',
    content: (
      <div>
        <h4 tabindex="0">Lattice Shape</h4>
        <p>
        You can choose between hexagonal and square lattice shape.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 4",
  },
  {
    selector: '[data-tour="4"]',
    content: (
      <div>
        <h4 tabindex="0">Lattice Size</h4>
        <p>
          Select the size of the lattice here. This determines the dimensions of
          the visualization of the model's output.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 5",
  },
  {
    selector: '[data-tour="5"]',
    content: (
      <div>
        <h4 tabindex="0">Setting Parameters</h4>
        <p>
          Some of these model parameters are specified by numerical values.
          <br></br>
          <br></br>You can set the value of a particular parameter by moving the
          sliding bar or by typing a value into the box. Note that for some
          parameters only integer values are allowed.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 6",
  },

  {
    selector: '[data-tour="6"]',
    content: (
      <div>
        <h4 tabindex="0">BTSC Transformation</h4>
        <p>
          Here you can allow the transformation of a randomly selected
          progenitor cell into a brain tumor stem cell.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 7",
  },

  {
    selector: '[data-tour="8"]',
    content: (
      <div>
        <h4 tabindex="0">Initialization Complete</h4>
        <p>
          Once you have specified all model parameters (note that you can use
          the default selection, as well) the initialization phase is completed.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 8",
  },
  {
    selector: '[data-tour="9"]',
    content: (
      <div>
        <h4 tabindex="0">Simulation</h4>
        <p>
          After initialization, the cellular automata model is ready to be
          simulated:<br></br>
          <br></br>Initialization → Simulation<br></br>
          <br></br>The simulator will run the model and generate an animation of
          how the neurosphere developed.<br></br>
          <br></br>To execute the simulation, please click on Run Model.
        </p>
      </div>
    ),
    navDotAriaLabel: "Step 9",
  },
];
